// extracted by mini-css-extract-plugin
export default {"days":"ug6x9","day":"XL7Ty","empty":"wjFyN"};